import { StoreOptions } from 'vuex';
import storage from '@/renderer/scripts/utils/storage';
import meeting from '@/renderer/scripts/utils/meeting';
import { SMH } from '@/renderer/scripts/smh';
import * as drawerEvents from './events';
interface DrawerState {
  spaceId: string;
  spaceOrgId?: number;
  coSpaceNoSelected: boolean;
  show: boolean;
  alive: boolean;
  total: undefined | number;
  type: 'space' | 'file' | 'folder' | 'files' | 'multi-select';
  tabs: string[];
  drawers: Array<Drawer.Scope<unknown>>;
  selectedDrawer: Drawer.Scope<unknown> | null;
  selectedList: unknown[]; // 选中的对象
  fileSwitchConfig: Drawer.FileListSwitchConfig | null;
  fileSwitchSelectedFile: SMH.SpaceFileItemData | null;
}
const drawer: StoreOptions<DrawerState> = {
  state: {
    // 抽屉是否存在
    alive: false,
    // 抽屉组件是否展示(腾讯会议中默认不展示，其他时候展示）
    show: !meeting.isTMWebview,
    // 文件总数
    total: 0,
    // 要展示的抽屉类型
    type: 'space',
    selectedList: [],
    // tableData.selectedList
    // 空间id
    spaceId: '',
    spaceOrgId: undefined,
    // 内部存放的所有面板
    coSpaceNoSelected: true,
    /// ////// 更新后 //////////
    // 展示的多个tabs类型
    tabs: [],
    drawers: [],
    selectedDrawer: null,
    fileSwitchConfig: null,
    fileSwitchSelectedFile: null,
  },
  mutations: {
    [drawerEvents.SET_SPACE_ORGID](state: DrawerState, spaceOrgId?: number) {
      state.spaceOrgId = spaceOrgId;
    },
    [drawerEvents.SET_DRAWERS](state: DrawerState, scopes: Drawer.Scope<unknown>[]) {
      state.alive = true;
      state.drawers = scopes;
    },
    [drawerEvents.SET_TOTAL](state: DrawerState, total: number): void {
      state.total = total;
    },
    [drawerEvents.SET_SELECTEDLIST](state: DrawerState, selectedList: any[]): void {
      state.selectedList = selectedList;
      storage.set(storage.StoreKey.COSPACE_SELECT_LIST, selectedList); // 避免在二级页刷新后无法邀请
    },

    // 开/关抽屉
    [drawerEvents.TOGGLE_DRAWER](state: DrawerState, val?: Boolean): void {
      //  若没有初始化组件，则不允许启用
      if (!state.alive) return;
      state.show = !!val;
    },
    [drawerEvents.SET_COSPACE_SELECTED](state: DrawerState, value: boolean): void {
      state.coSpaceNoSelected = value;
    },
    // 创建抽屉
    [drawerEvents.INITIAL_DRAWER](state: DrawerState, params: any): void {
      state.alive = true;
      state.show = true;
    },
    // 销毁抽屉
    [drawerEvents.DESTORY_DRAWER](state: DrawerState): void {
      state.alive = false;
    },
    [drawerEvents.SET_DRAWERS_FILE_INDICATOR](state: DrawerState, config: Drawer.FileListSwitchConfig | null) {
      state.fileSwitchConfig = config;
      state.fileSwitchSelectedFile = config?.selectedFile ?? null;
    },
    [drawerEvents.SET_DRAWERS_FILE_INDICATOR_SELECTED](state: DrawerState, selectedFile: SMH.SpaceFileItemData) {
      state.fileSwitchSelectedFile = selectedFile;
      if (!state.fileSwitchConfig) return;
      state.fileSwitchConfig.selectedFile = selectedFile;
    },
    [drawerEvents.DRAWER_SELECTED_TAB](state: DrawerState, selectedDrawer: Drawer.Scope<unknown>) {
      state.selectedDrawer = selectedDrawer;
    },
  },
  getters: {
    drawerSelected: (state: DrawerState): DrawerState['selectedList'] => {
      if (state.selectedList.length) return state.selectedList;
      return storage.get(storage.StoreKey.COSPACE_SELECT_LIST);
    },
    drawerShow: (state: DrawerState) => state.show,
    drawerAlive: (state: DrawerState) => state.alive,
  },
};
export default drawer;
